:root {
  color: #4b4b4b;
  background: #f5f5f5;
  font-family: Arial, Helvetica, sans-serif;
  line-height: 1.45;
}

/* cod5 final polish: reduce placeholder blanks from the source recreation */
.topBlank,
.heroGap,
.awards,
.bottomGap,
.clientPage,
.blogPage {
  min-height: auto;
}

.heroGap {
  padding-top: clamp(72px, 9vw, 120px);
  padding-bottom: clamp(72px, 9vw, 120px);
}

.awards,
.bottomGap,
.blogPage,
.clientPage {
  padding-top: clamp(56px, 7vw, 92px);
  padding-bottom: clamp(56px, 7vw, 92px);
}

.people article,
.areaGrid article,
.clientBox,
.blogPage article {
  box-shadow: 0 18px 46px rgba(82, 74, 61, 0.10);
}

@media (max-width: 760px) {
  .topBlank,
  .heroGap,
  .awards,
  .bottomGap,
  .clientPage,
  .blogPage {
    min-height: auto;
  }
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #f5f5f5;
}

a {
  color: inherit;
  text-decoration: none;
}

img {
  display: block;
  max-width: 100%;
}

header {
  height: 75px;
  background: #a17a3d;
  color: #ffffff;
}

.topMini {
  height: 18px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: max(46px, calc((100vw - 1180px) / 2));
  background: #8d6a35;
  font-size: 0.68rem;
}

.navBar {
  width: min(1180px, calc(100% - 80px));
  height: 57px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 auto;
}

.brand img {
  width: 136px;
}

nav {
  display: flex;
  align-items: center;
  gap: 30px;
  font-size: 0.72rem;
}

.hero {
  position: relative;
  min-height: clamp(420px, 56vw, 680px);
  display: grid;
  place-items: center;
  overflow: hidden;
  background: #ece7dc;
  text-align: center;
}

.hero img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hero::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(245, 245, 245, 0.3), rgba(42, 32, 24, 0.38));
}

.hero > div {
  position: relative;
  z-index: 1;
  margin-top: 80px;
  padding: 28px 36px;
  background: rgba(245, 245, 245, 0.86);
  color: #5d4524;
}

.hero h1 {
  margin: 0 0 8px;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(2rem, 5vw, 4rem);
  font-weight: 400;
}

.hero p {
  margin: 0 0 18px;
  color: #6f675d;
}

.hero a,
.clientShortcut,
.blogPostPreview a {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0 16px;
  background: #a17a3d;
  color: #ffffff;
  font-size: 0.72rem;
  text-transform: uppercase;
}

.topBlank {
  min-height: 650px;
  background: #f7f7f7;
}

.cookie {
  min-height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 18px;
  border-top: 1px solid #dedede;
  border-bottom: 1px solid #dedede;
  background: #f7f7f7;
  color: #777;
  font-size: 0.68rem;
}

.cookie button {
  border: 0;
  background: #595959;
  color: #fff;
  padding: 4px 16px;
  font-size: 0.68rem;
}

.heroGap {
  min-height: 3200px;
  background: #f7f7f7;
}

.people {
  width: min(1180px, calc(100% - 120px));
  margin: 0 auto;
  text-align: center;
}

h2 {
  display: flex;
  align-items: center;
  gap: 18px;
  margin: 0 0 34px;
  color: #777;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1.42rem;
  font-weight: 400;
}

h2::before,
h2::after {
  content: "";
  height: 1px;
  flex: 1;
  background: #cfcfcf;
}

.partners {
  display: flex;
  justify-content: center;
  gap: 34px;
  margin-bottom: 52px;
}

.partners article {
  width: 165px;
  min-height: 342px;
  background: #ffffff;
  border: 1px solid #dedede;
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.06);
}

.partners img {
  width: 100%;
  height: 206px;
  object-fit: cover;
}

h3 {
  margin: 18px 10px 8px;
  color: #333333;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.95rem;
  line-height: 1.2;
}

.partners span,
.team span {
  color: #b38a4a;
  font-size: 0.72rem;
  text-transform: uppercase;
}

.team {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px 34px;
  margin-bottom: 56px;
}

.team article {
  min-height: 68px;
  display: grid;
  place-items: center;
  background: #ffffff;
  border: 1px solid #dedede;
}

.team h3 {
  margin: 0 10px 3px;
  font-size: 0.9rem;
}

.areas {
  background: #eeeeee;
  padding: 38px 0 72px;
}

.areas > h2 {
  width: min(1180px, calc(100% - 120px));
  margin-left: auto;
  margin-right: auto;
}

.areaGrid {
  width: min(1180px, calc(100% - 120px));
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px 34px;
  margin: 0 auto;
}

.areaGrid article {
  display: grid;
  grid-template-columns: 34px 1fr;
  gap: 14px;
}

.areaGrid article > span {
  width: 26px;
  height: 26px;
  display: grid;
  place-items: center;
  background: #d7a655;
  color: #ffffff;
  font-weight: 700;
}

.areaGrid h3 {
  margin: 0 0 6px;
  font-size: 0.9rem;
}

.areaGrid p {
  margin: 0;
  color: #555;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.76rem;
  line-height: 1.35;
  text-align: justify;
}

.awards {
  min-height: 1300px;
  background: #eeeeee;
}

.awards > div {
  width: min(1180px, calc(100% - 120px));
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px 34px;
  margin: 0 auto;
}

.awards article {
  min-height: 62px;
  display: flex;
  align-items: center;
  border-left: 1px solid #d7a655;
  background: linear-gradient(90deg, #d7a655 0 26px, transparent 26px);
  padding-left: 14px;
}

.awards h3 {
  margin: 0;
  font-size: 0.86rem;
}

.bottomGap {
  min-height: 3440px;
  background: #eeeeee;
}

.footerMini {
  min-height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 42px;
  background: #f5f5f5;
  color: #777;
  font-size: 0.72rem;
}

.clientPage {
  min-height: 760px;
  width: min(920px, calc(100% - 80px));
  margin: 0 auto;
  padding: 150px 0;
}

.clientPage h2,
.blogPage h2 {
  display: block;
}

.clientPage h2::before,
.clientPage h2::after,
.blogPage h2::before,
.blogPage h2::after {
  display: none;
}

.loginBox {
  width: min(420px, 100%);
  display: grid;
  gap: 12px;
  margin-top: 34px;
}

.loginBox label {
  display: grid;
  grid-template-columns: 70px 1fr;
  align-items: center;
  gap: 8px;
}

.loginBox input,
.blogSidebar input {
  min-height: 32px;
  border: 1px solid #ccc;
  background: #fff;
  padding: 5px 8px;
  font: inherit;
}

.loginBox button {
  width: 120px;
  min-height: 32px;
  border: 0;
  background: #a17a3d;
  color: #fff;
}

.blogPage {
  min-height: 1160px;
  width: min(1180px, calc(100% - 80px));
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 56px;
  margin: 0 auto;
  padding: 90px 0 120px;
}

.contactPage {
  width: min(1180px, calc(100% - 80px));
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: 48px;
  align-items: start;
  margin: 0 auto;
  padding: 82px 0 96px;
}

.contactPage h2 {
  display: block;
}

.contactPage h2::before,
.contactPage h2::after {
  display: none;
}

.contactPage p {
  color: #666;
  font-family: Georgia, "Times New Roman", serif;
}

.contactPage strong {
  display: block;
  margin-bottom: 12px;
  color: #5d4524;
}

.contactChannels {
  display: grid;
  gap: 8px;
  margin: 20px 0 24px;
  color: #5d4524;
  font-size: 0.9rem;
}

.contactChannels a {
  color: #5d4524;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.contactForm {
  display: grid;
  gap: 14px;
  padding: 30px;
  background: #ffffff;
  border: 1px solid #dedede;
  box-shadow: 0 18px 46px rgba(82, 74, 61, 0.10);
}

.contactForm label {
  display: grid;
  gap: 7px;
  color: #5d4524;
  font-size: 0.78rem;
  text-transform: uppercase;
}

.formGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 14px;
}

.contactForm input,
.contactForm select,
.contactForm textarea {
  width: 100%;
  min-height: 36px;
  border: 1px solid #cfcfcf;
  background: #f8f8f8;
  padding: 8px 10px;
  color: #333;
  font: inherit;
  text-transform: none;
}

.contactForm textarea {
  resize: vertical;
}

.contactForm button {
  width: fit-content;
  min-height: 36px;
  border: 0;
  background: #a17a3d;
  color: #ffffff;
  padding: 0 18px;
  font-size: 0.72rem;
  text-transform: uppercase;
}

.breadcrumb {
  grid-column: 1 / -1;
  color: #888;
  font-size: 0.8rem;
}

.blogPostPreview {
  background: #fff;
  border: 1px solid #dedede;
  padding: 34px;
}

.blogPostPreview img {
  width: 100%;
  max-height: 280px;
  object-fit: cover;
  margin-bottom: 24px;
}

.blogPostPreview span,
.blogPostPreview strong,
.blogSidebar h6 {
  color: #a17a3d;
  font-size: 0.72rem;
  text-transform: uppercase;
}

.blogPostPreview p,
.blogSidebar p,
.calendar {
  color: #666;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.86rem;
}

.blogSidebar {
  background: #fff;
  border: 1px solid #dedede;
  padding: 28px;
}

.calendar {
  margin-top: 18px;
  line-height: 1.8;
}

.blogArticle {
  width: min(880px, calc(100% - 80px));
  margin: 0 auto;
  padding: 82px 0 104px;
}

.blogArticle > img {
  width: 100%;
  max-height: 420px;
  object-fit: cover;
  margin: 28px 0;
}

.blogArticle span {
  color: #a17a3d;
  font-size: 0.72rem;
  text-transform: uppercase;
}

.blogArticle h1 {
  margin: 12px 0 24px;
  color: #333;
  font-family: Georgia, "Times New Roman", serif;
  font-size: clamp(2rem, 4vw, 3.2rem);
  font-weight: 400;
}

.blogArticle p {
  color: #666;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 1rem;
  line-height: 1.7;
}

@media (max-width: 700px) {
  header {
    height: auto;
  }

  .navBar {
    width: calc(100% - 28px);
    height: auto;
    flex-direction: column;
    align-items: flex-start;
    padding: 14px 0;
  }

  nav {
    width: 100%;
    overflow-x: auto;
    gap: 18px;
    padding-top: 10px;
    white-space: nowrap;
  }

  .topBlank {
    min-height: 760px;
  }

  .heroGap {
    min-height: 5600px;
  }

  .people,
  .areas > h2,
  .areaGrid,
  .awards > div {
    width: calc(100% - 36px);
  }

  .partners,
  .team,
  .areaGrid,
  .awards > div {
    grid-template-columns: 1fr;
  }

  .partners {
    display: grid;
  }

  .partners article {
    width: 100%;
  }

  .areaGrid {
    gap: 24px;
  }

  .awards {
    min-height: 2400px;
  }

  .bottomGap {
    min-height: 6430px;
  }

  .footerMini,
  .blogPage,
  .contactPage {
    flex-direction: column;
  }

  .blogPage,
  .contactPage {
    width: calc(100% - 36px);
    grid-template-columns: 1fr;
  }

  .homeContact,
  .formGrid {
    grid-template-columns: 1fr;
  }

  .homeContact {
    padding-left: 18px;
    padding-right: 18px;
  }

  .blogPage {
    min-height: 1500px;
  }

  .clientPage {
    width: calc(100% - 36px);
  }

  .hero {
    min-height: 430px;
  }

  .hero > div {
    width: calc(100% - 44px);
    margin-top: 44px;
    padding: 24px 20px;
  }

  .blogArticle {
    width: calc(100% - 36px);
  }
}

/* cod5 final override: remove artificial WordPress placeholders after base rules */
.topBlank,
.heroGap,
.bottomGap {
  display: none;
}

.people {
  padding-top: clamp(48px, 6vw, 84px);
  padding-bottom: clamp(42px, 5vw, 72px);
}

.awards {
  min-height: auto !important;
  padding-top: clamp(46px, 6vw, 82px);
  padding-bottom: clamp(58px, 7vw, 96px);
}

.clientPage,
.blogPage {
  min-height: auto !important;
}

@media (max-width: 700px) {
  .people {
    padding-top: 34px;
  }

  .awards {
    min-height: auto !important;
    padding-top: 40px;
    padding-bottom: 52px;
  }
}

/* cod5 2026-05-28: restore missing institutional sections from the WordPress home */
.aboutIntro,
.values,
.publications {
  width: min(1180px, calc(100% - 120px));
  margin: 0 auto;
  padding-top: clamp(52px, 7vw, 90px);
  padding-bottom: clamp(52px, 7vw, 90px);
}

.aboutIntro {
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(320px, 1.1fr);
  gap: 48px;
  align-items: center;
}

.aboutIntro h2,
.values h2,
.publications h2,
.homeContact h2 {
  display: block;
}

.aboutIntro h2::before,
.aboutIntro h2::after,
.values h2::before,
.values h2::after,
.publications h2::before,
.publications h2::after,
.homeContact h2::before,
.homeContact h2::after {
  display: none;
}

.aboutIntro p,
.values p,
.homeContact p {
  color: #5c5751;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 0.98rem;
  line-height: 1.65;
}

.aboutIntro img {
  width: 100%;
  max-height: 430px;
  object-fit: cover;
  border: 1px solid #dedede;
}

.values {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.values article,
.publications article,
.homeContactIntro {
  background: rgba(255, 255, 255, 0.94);
  border: 1px solid #dedede;
  box-shadow: 0 18px 46px rgba(82, 74, 61, 0.10);
}

.values article {
  min-height: 190px;
  padding: 28px;
}

.publications {
  width: 100%;
  background: #f5f5f5;
}

.publications > h2,
.publications > div,
.awards > h2 {
  width: min(1180px, calc(100% - 120px));
  margin-left: auto;
  margin-right: auto;
}

.publications > div {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 22px;
}

.publications article {
  overflow: hidden;
}

.publications img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  object-position: top;
}

.publications h3 {
  min-height: 54px;
  display: flex;
  align-items: center;
  margin: 0;
  padding: 16px 18px;
}

.awards > h2 {
  margin-bottom: 34px;
}

.awards article {
  border-left: 1px solid #d7a655;
  background: linear-gradient(90deg, #d7a655 0 26px, transparent 26px);
}

.homeContact {
  width: 100%;
  display: grid;
  grid-template-columns: minmax(0, 0.75fr) minmax(360px, 1fr);
  gap: 28px;
  background: #eeeeee;
  padding: clamp(52px, 7vw, 90px) max(40px, calc((100vw - 1180px) / 2));
}

.homeContactIntro {
  align-self: start;
  padding: 36px;
}

.homeContact .contactForm {
  align-self: start;
}

@media (max-width: 700px) {
  .aboutIntro,
  .values,
  .publications > h2,
  .publications > div,
  .awards > h2 {
    width: calc(100% - 36px);
  }

  .aboutIntro,
  .values,
  .publications > div {
    grid-template-columns: 1fr;
  }

  .publications img {
    height: 260px;
  }
}
